<div class="cat-detalle" [formGroup]="editable.grupo">
  <!-- Datos de la categoría -->
  <div class="grid">
    <mat-form-field appearance="outline">
      <mat-label>Nombre</mat-label>
      <input matInput formControlName="nombre" required />
      @if (editable.grupo.controls["nombre"].hasError("required")) {
        <mat-error>Obligatorio.</mat-error>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      matTooltip="Distingue dos categorías que se llaman igual (ej. Normal / Normal Comercio)"
    >
      <mat-label>Variante</mat-label>
      <input matInput formControlName="variante" />
      <mat-hint>Si hay dos con el mismo nombre.</mat-hint>
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      matTooltip="Cuando las zonas de dos categorías se solapan, se aplica la de prioridad más baja"
    >
      <mat-label>Prioridad</mat-label>
      <input matInput type="number" formControlName="prioridad" required />
      <mat-hint>Gana la más baja al solaparse.</mat-hint>
    </mat-form-field>
    @if (variantes.length) {
      <mat-form-field
        appearance="outline"
        [matTooltip]="
          'Variantes que distingue ' +
            (templateCustom?.label ?? '') +
            '. En blanco usa la primera.'
        "
      >
        <mat-label>Variante de pantalla</mat-label>
        <mat-select formControlName="nombreTemplate">
          @for (v of variantes; track v) {
            <mat-option [value]="v">{{ v }}</mat-option>
          }
        </mat-select>
        <mat-hint>Sub-vista del template.</mat-hint>
      </mat-form-field>
    } @else {
      <mat-form-field
        appearance="outline"
        [matTooltip]="
          bloqueado
            ? (templateCustom?.label ?? '') +
              ' no usa la variante: dibuja lo mismo para todas las categorías'
            : 'Sub-vista dentro del template (ej. violencia de genero). En blanco = normal'
        "
      >
        <mat-label>Variante de pantalla</mat-label>
        <input matInput formControlName="nombreTemplate" />
        <mat-hint>
          @if (bloqueado) {
            No la usa este template.
          } @else {
            Sub-vista del template.
          }
        </mat-hint>
      </mat-form-field>
    }
  </div>

  <!-- Plantilla de botonera de ESTA categoría. Con template hecho a mano no se elige. -->
  @if (bloqueado) {
    <div class="aviso-custom">
      <mat-icon>phonelink_lock</mat-icon>
      <div>
        <strong>Este cliente usa un template personalizado en la app mobile.</strong>
        <p>
          La pantalla de inicio es <strong>{{ templateCustom?.label }}</strong>,
          escrita a mano en la app y anclada al bundle ID
          <code>{{ templateCustom?.bundleIds?.[0] }}</code>. Por eso la
          botonera no se puede elegir desde acá.
        </p>
        @if (templateCustom?.nota) {
          <p class="chico">{{ templateCustom?.nota }}</p>
        }
        <p class="chico">
          Sí se configuran desde acá: los botones, cómo se reparten en las
          pantallas, la variante y las imágenes de la categoría.
        </p>
      </div>
    </div>

    @if (pisaTemplateCustom) {
      <div class="aviso-custom peligro">
        <mat-icon>warning</mat-icon>
        <div>
          <strong>Hay una botonera genérica guardada en esta categoría
            ("{{ botoneraPropia }}").</strong>
          <p>
            En la app la categoría le gana al cliente, así que eso le está
            reemplazando la pantalla de {{ templateCustom?.label }}. Conviene
            limpiarlo.
          </p>
          <button
            mat-stroked-button
            color="warn"
            type="button"
            (click)="limpiarBotonera()"
          >
            <mat-icon>backspace</mat-icon> Quitar la botonera genérica
          </button>
        </div>
      </div>
    }
  } @else {
    <span class="chooser-lbl">Plantilla de botonera</span>
    <div
      class="chooser"
      [style.--brand]="clienteFormValue?.configuracion?.colorTema || '#FB972E'"
    >
      <div class="choices">
        <!-- Sin plantilla propia: hereda la del cliente (o la custom anclada al bundleId). -->
        <div
          class="choice"
          [class.on]="!botoneraPropia"
          matTooltip="La categoría no fija plantilla: usa la del cliente (o la custom del bundleId)."
          (click)="setBotonera(null)"
        >
          <div class="mini m-heredado"><i class="dash"></i></div>
          <div class="ch-ttl">Usar la del cliente</div>
        </div>
        @for (o of botoneraOpciones; track o.id) {
          <div
            class="choice"
            [class.on]="botoneraPropia === o.id"
            [matTooltip]="o.descripcion"
            (click)="setBotonera(o.id)"
          >
            <div class="mini" [ngClass]="'m-' + o.id">
              @switch (o.id) {
                @case ("grid") {
                  <i class="bar b1"></i><i class="bar b2"></i
                  ><i class="bar b3"></i>
                }
                @case ("banner") {
                  <i class="bn"></i><i class="bar b2"></i><i class="bar b3"></i>
                }
                @case ("centrado") {
                  <i class="bn"></i><i class="big"></i>
                }
                @case ("hub") {
                  <i class="t1"></i><i class="t2"></i><i class="t3"></i
                  ><i class="t4"></i>
                }
              }
            </div>
            <div class="ch-ttl">{{ o.label }}</div>
          </div>
        }
        <!-- Plantilla armada a mano: piezas apiladas que se configuran abajo. -->
        <div
          class="choice"
          [class.on]="esManual"
          matTooltip="Armá la pantalla pieza por pieza: imágenes, botones, fila de acciones, textos."
          (click)="setBotonera(idManual)"
        >
          <div class="mini m-manual">
            <i class="p1"></i><i class="p2"></i><i class="p3"></i
            ><mat-icon>edit</mat-icon>
          </div>
          <div class="ch-ttl">Armada a mano</div>
        </div>
      </div>
    </div>
    @if (!botoneraPropia) {
      <p class="nota">{{ textoHerencia }}</p>
    }
  }

  <div class="split">
    <div class="split-form">
      <!-- ===================== BOTONES ===================== -->
      <h3>Botones de la categoría</h3>
      <p class="nota">
        Un botón nuevo se crea al guardar. Uno existente se usa por referencia:
        para cambiarlo, editalo en el módulo Botones.
      </p>

      @for (
        g of botonesControls;
        track g.get("_tmpId")?.value;
        let i = $index
      ) {
        <div class="boton-item">
          <div class="boton-item-head">
            <strong>Botón {{ i + 1 }}</strong>
            @if (esExistente(g)) {
              <span class="badge-existente">Existente</span>
            } @else {
              <span class="badge-nuevo">Nuevo</span>
            }
            <button
              mat-icon-button
              color="warn"
              type="button"
              matTooltip="Quitar de la categoría"
              (click)="eliminarBoton(i)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>

          @if (esExistente(g)) {
            <div class="boton-resumen">
              @if (g.get("urlImagen")?.value) {
                <img class="thumb" [src]="g.get('urlImagen')?.value" alt="" />
              } @else {
                <span
                  class="swatch"
                  [style.background]="g.get('color')?.value || '#e7e2d8'"
                  >{{ g.get("texto")?.value }}</span
                >
              }
              <div class="boton-resumen-datos">
                <strong>
                  {{ g.get("nombre")?.value }}
                  {{
                    g.get("variante")?.value
                      ? "(" + g.get("variante")?.value + ")"
                      : ""
                  }}
                </strong>
                <span>{{ g.get("funcion")?.value }}</span>
              </div>
            </div>
          } @else {
            <ng-select
              #selExistente
              class="select-existente"
              [items]="botonesCatalogo"
              placeholder="Usar un botón ya creado (opcional)"
              [searchFn]="searchBoton"
              bindLabel="nombre"
              appendTo="body"
              (change)="usarExistente(i, $event, selExistente)"
            >
              <ng-template ng-option-tmp let-item="item">
                <span>
                  {{ item.nombre }}
                  {{ item.variante ? "(" + item.variante + ")" : "" }}
                </span>
              </ng-template>
            </ng-select>
            <app-boton-form
              [group]="g"
              [botoneraId]="botoneraId"
              [cantidadPrincipales]="cantidadPrincipales"
            />
          }
        </div>
      }

      <button
        mat-stroked-button
        color="primary"
        type="button"
        (click)="agregarBoton()"
      >
        <mat-icon>add</mat-icon> Agregar botón
      </button>

      <!-- ===================== PANTALLAS ===================== -->
      @if (esManual) {
        <!-- Plantilla armada a mano: cada pantalla se arma con piezas y los botones se eligen
             en cada pieza (eso define en qué pantalla queda cada botón). -->
        <h3>Pantallas (armadas a mano)</h3>
        <p class="nota">
          Cada pantalla se dibuja con sus piezas, de arriba hacia abajo. En las
          piezas de botones y en las filas elegís qué botones van.
        </p>
        @if (botonesSinUsar.length) {
          <p class="nota warn">
            <mat-icon inline>warning</mat-icon>
            {{ botonesSinUsar.length }} botón(es) de la categoría no están en
            ninguna pieza: el vecino no los ve ({{ botonesSinUsar.join(", ") }}).
          </p>
        }
        <app-plantilla-manual-editor
          [plantilla]="plantillaManual"
          [botones]="botonesElegibles"
          [sirenas]="sirenas"
          [colorTema]="previewVm.brand"
          [(pantalla)]="pantallaManual"
          (plantillaChange)="setPlantilla($event)"
        />
      } @else {
        <h3>Pantallas</h3>
        <app-pantallas-armado
          [botones]="editable.botones"
          [idsPantalla1]="editable.idsPantalla1"
          [idsPantalla2]="editable.idsPantalla2"
          [idsPantalla3]="editable.idsPantalla3"
        />
      }

      <!-- ===================== IMÁGENES ===================== -->
      @if (slotsNativos.length) {
        <h3>Imágenes de la categoría</h3>
        <p class="nota">
          Vacío = usa la imagen del cliente. Lo que cargues acá la pisa solo
          para esta categoría.
        </p>
        @if (cantidadSinUso) {
          <p class="nota warn">
            <mat-icon inline>info</mat-icon>
            {{ cantidadSinUso }} de estos slots no los dibuja
            {{ templateCustom?.label }}: se guardan igual, pero no se ven en la
            app.
          </p>
        }
        @if (!nombreValido) {
          <p class="nota warn">
            Poné el nombre del cliente para habilitar las subidas.
          </p>
        }
        <div class="slots">
          @for (slot of slotsNativos; track slot.control) {
            <div class="slot" [class.sin-uso]="slot.sinUso">
              <span class="slot-label">
                {{ slot.label }}
                @if (slot.sinUso) {
                  <span
                    class="badge-sin-uso"
                    [matTooltip]="
                      (templateCustom?.label ?? 'Este template') +
                        ' no dibuja esta imagen: se guarda pero no se ve'
                    "
                    >no se usa</span
                  >
                }
              </span>
              <span class="slot-hint">{{ slot.hint }}</span>
              @if (cargadaYSinUso(slot)) {
                <span class="slot-alerta">
                  Hay una imagen cargada que la app ignora.
                </span>
              }
              <div class="slot-row">
                @if (editable.imagenes.get(slot.control)?.value) {
                  <img
                    class="thumb"
                    [src]="editable.imagenes.get(slot.control)?.value"
                    alt=""
                  />
                }
                <button
                  mat-stroked-button
                  type="button"
                  [disabled]="loading || !nombreValido"
                  (click)="inpNativo.click()"
                >
                  <mat-icon>upload</mat-icon> Subir
                </button>
                <input
                  #inpNativo
                  type="file"
                  accept="image/*"
                  hidden
                  (change)="setFile($event, slot.control)"
                />
                @if (slot.control === "fondo") {
                  <!-- Fondo de un color: se genera una imagen lisa y se sube como el fondo. -->
                  <button
                    mat-stroked-button
                    type="button"
                    class="btn-color-fondo"
                    matTooltip="Usar un color liso como fondo de pantalla"
                    [disabled]="loading || !nombreValido"
                    ngx-colors-trigger
                    [ngModel]="colorFondoActual"
                    [ngModelOptions]="{ standalone: true }"
                    [formats]="['hex']"
                    colorPickerControls="no-alpha"
                    acceptLabel="Usar"
                    cancelLabel="Cancelar"
                    (open)="fondoCambiado = false"
                    (input)="fondoCambiado = true"
                    (close)="setColorFondo($event)"
                  >
                    <mat-icon>palette</mat-icon> Color
                  </button>
                }
                @if (editable.imagenes.get(slot.control)?.value) {
                  <button
                    mat-icon-button
                    color="warn"
                    type="button"
                    matTooltip="Volver a la imagen del cliente"
                    (click)="limpiarSlot(slot.control)"
                  >
                    <mat-icon>backspace</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      }

      <!-- Solo web legacy: el nativo no las usa. -->
      <mat-expansion-panel class="legacy">
        <mat-expansion-panel-header>
          <mat-panel-title>Imágenes de la web legacy</mat-panel-title>
          <mat-panel-description>
            {{ cantidadLegacy }} cargada(s) · la app nativa no las usa
          </mat-panel-description>
        </mat-expansion-panel-header>
        <div class="slots">
          @for (slot of slotsLegacy; track slot.control) {
            <div class="slot">
              <span class="slot-label">{{ slot.label }}</span>
              <div class="slot-row">
                @if (editable.imagenesLegacy.get(slot.control)?.value) {
                  <img
                    class="thumb"
                    [src]="editable.imagenesLegacy.get(slot.control)?.value"
                    alt=""
                  />
                }
                <button
                  mat-stroked-button
                  type="button"
                  [disabled]="loading || !nombreValido"
                  (click)="inpLegacy.click()"
                >
                  <mat-icon>upload</mat-icon> Subir
                </button>
                <input
                  #inpLegacy
                  type="file"
                  accept="image/*"
                  hidden
                  (change)="setFile($event, slot.control, true)"
                />
                @if (editable.imagenesLegacy.get(slot.control)?.value) {
                  <button
                    mat-icon-button
                    color="warn"
                    type="button"
                    (click)="limpiarSlot(slot.control, true)"
                  >
                    <mat-icon>backspace</mat-icon>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      </mat-expansion-panel>
    </div>

    <!-- Preview en vivo. Solo las botoneras genéricas se pueden dibujar acá: los templates
         hechos a mano viven en el nativo y no hay forma de reproducirlos. -->
    <div class="split-preview">
      @if (esManual) {
        <app-plantilla-manual-preview
          [plantilla]="plantillaManual"
          [vm]="previewVm"
          [botones]="botonesPreview"
          [(pantalla)]="pantallaManual"
        />
      } @else if (esGenerica) {
        <app-provisionador-preview [vm]="previewVm" [soloBotonera]="true" />
        @if (!botoneraPropia) {
          <p class="nota preview-nota">Heredado del cliente, no de la categoría.</p>
        }
      } @else {
        <div class="preview-fijo">
          <mat-icon>phonelink_lock</mat-icon>
          <strong>Layout fijo en la app mobile</strong>
          <p>{{ textoHerencia }}</p>
          <p class="chico">
            Los templates personalizados están hechos a mano en la app y se
            resuelven por bundle ID: no se pueden previsualizar ni configurar
            desde acá. Lo que sí se aplica son los botones, las pantallas y las
            imágenes de abajo.
          </p>
        </div>
      }
    </div>
  </div>
</div>
